import axios from "./config";

const getReportComments = (procuringEntityReportId) => {
  return axios
    .get(`/report-comments`, { params: { procuring_entity_report_id: procuringEntityReportId } })
    .then((response) => response.data);
};

const createReportComment = (procuringEntityReportId, body) => {
  return axios
    .post(`/report-comments`, {
      procuring_entity_report_id: procuringEntityReportId,
      body,
    })
    .then((response) => response.data);
};

const updateReportComment = (id, body) => {
  return axios.put(`/report-comments/${id}`, { body }).then((response) => response.data);
};

const deleteReportComment = (id) => {
  return axios.delete(`/report-comments/${id}`).then((response) => response.data);
};

export default {
  getReportComments,
  createReportComment,
  updateReportComment,
  deleteReportComment,
};
